export default __webpack_public_path__ + "static/media/74.429b49e4.png";